<template>
  <div>
    <div v-if="loading">
    <v-col cols="3" align="center">
      <Loading/>
    </v-col>
  </div>
  <div v-if="!loading">
    <v-col :cols="$vuetify.breakpoint.smAndDown ? '11' : '10'" class="white info--text" style="position: absolute; z-index: 1; border-radius: 30px;">
      <v-container>
        <v-row>
          <v-col>
            Quote <span class="primary--text">#{{  + Number.parseInt(order+1) }}</span>
          </v-col>
        </v-row>

        <v-row justify="start" v-if="$vuetify.breakpoint.smAndDown">
          <v-col>
            <h3 class="info--text">Enter your mobile number and email address</h3>
          </v-col>
        </v-row>
        <v-row v-if="$vuetify.breakpoint.smAndDown" justify="start" style="display: block;">
          <v-col md="4" align="start">
            <v-text-field background-color="grey lighten-3" solo type="number" label="Mobile number eg: 0671234567" v-model="mobile"></v-text-field>
            <v-text-field background-color="grey lighten-3" solo label="Enter your email address" v-model="emailAddress"></v-text-field>
          </v-col>
        </v-row>

        <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
          <v-col :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
            <h1 class="mb-4">Here's your quote</h1>
          </v-col>
          <v-col align="end" :style="$vuetify.breakpoint.smAndDown ? 'display: block; text-align: center;' : ''">
            <v-btn :block="$vuetify.breakpoint.smAndDown" rounded outlined style="border: 1px solid black;" height="60" class="min-width" v-on:click="sendQuote" :disabled="disabled">Email quote</v-btn>
          </v-col>
          <v-col align="start" :style="$vuetify.breakpoint.smAndDown ? 'display: block; text-align: center;' : ''">
            <v-btn :block="$vuetify.breakpoint.smAndDown" rounded height="60" class="primary min-width" v-on:click="saveQuoteEventHandler">Book now</v-btn>
          </v-col>
        </v-row>

        <v-row justify="start" v-if="!$vuetify.breakpoint.smAndDown">
          <v-col>
            <h3 class="info--text">Enter your mobile number and email address</h3>
          </v-col>
        </v-row>
        <v-row v-if="!$vuetify.breakpoint.smAndDown" justify="start">
          <v-col md="4" align="start">
            <v-text-field background-color="grey lighten-3" solo type="number" label="Mobile number eg: 0671234567" v-model="mobile"></v-text-field>
          </v-col>
          <v-col md="4" align="start">
            <v-text-field background-color="grey lighten-3" solo label="Enter your email address" v-model="emailAddress"></v-text-field>
          </v-col>
        </v-row>

        <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
          <v-col>
            <v-card elevation="10" height="200" class="grey lighten-4">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h2 v-if="vehicle.name.includes('Skip')" class="black--text mb-4">Delivery</h2>
                    <h2 v-if="!vehicle.name.includes('Skip')" class="black--text mb-4">Collection</h2>
                  </v-col>
                  <v-col align="end">
                    <h2 class="primary--text"> $ {{ vehicle.cost }} </h2>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p v-if="vehicle.name.includes('Dumpster')">
                      Dumpster placement, collection, disposal and landfill dump charges* (VAT inclusive)
                    </p>
                    <p v-if="!vehicle.name.includes('Dumpster')">
                      Collection, disposal and landfill dump charges* (VAT inclusive)
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="vehicle.name.includes('Dumpster')">
            <v-card elevation="0" height="200" class="grey lighten-4">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h2 v-if="vehicle.name.includes('Dumpster')" class="black--text mb-4">Exchange</h2>
                  </v-col>
                  <v-col align="end">
                    <h2 class="primary--text"> $ {{ vehicle.cost }} </h2>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p>
                      Full bin collection and bring a new bin (exchange)
                      Bin exchange, disposal and landfill dump charges* (VAT inclusive) 
                      Dumpster bin rental for 7 days
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            About your project
          </v-col>
          <v-col align="end">
            #{{ parseInt(order+1) }}
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block' : ''">
          <v-col>
            <h4 class="black--text mb-2">Your waste address is </h4>
            {{ capturedAddress }}
          </v-col>
          <v-col>
            <h4 class="black--text mb-2">Waste type </h4>
            {{ wasteType.name }}
          </v-col>
          <v-col>
            <h4 class="black--text mb-2">Service type </h4>
            <span> {{ vehicle.name }} </span>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </div>
</div>
</template>

<script>
import { getFunctions, httpsCallable } from 'firebase/functions'
import { addDoc, getFirestore, collection } from '@firebase/firestore';
import Loading from "@/components/Loading";
const db = getFirestore();
const functions = getFunctions();
const phoneRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3}?)[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/

export default {
  name: "ConfirmInfo",
  props: {
    wasteType: Object,
    vehicle: Object,
    capturedAddress: String,
    location: Object,
    postCode: String
  },
  components:{
    Loading
  },
  data() {
    return {
      booking: {},
      isSendingEmail: false,
      timeStamp: new Date(),
      user: {},
      emailAddress: '',
      mobile: '',
      loading: false,
      disabled: false
    }
  },
  methods: {
    sendQuote() {
      if(!phoneRegex.test(this.mobile)){
        alert('Missing or incorrect mobile number');
        return;
      }
      else if(!this.emailAddress){
        alert('Missing or incorrect email address');
        return;
      }
      else{
        this.disabled = true;
        this.loading = true;
        window.scrollTo(0, 0);
        const sendFastQuote = httpsCallable(functions, 'sendFastQuote');
        const successCallback = () => alert(`We have emailed your quote. To book in 60 seconds please sign up.`);
        const errorCallback = () => alert(`Failed to send email to ${this.emailAddress}, please try again later`);

        this.saveQuote().then((snapshot) => {
          const quoteId = snapshot.id;
          sendFastQuote({ ...this.booking, emailAddress: this.emailAddress, quoteId: quoteId })
              .then(function() {
                successCallback();
              })
              .catch((error) => {
                errorCallback();
                console.log(error);
              });
               this.loading = false;
        }).catch((error) => {
          this.loading = false;
          console.log(error);
          alert('Failed to save quote to database');
        });
      }
    },
    async saveQuoteEventHandler() { 
      this.loading = true;
      window.scrollTo(0, 0);
      this.saveQuote().then((ref) => {
        alert('Booking in progress. Please sign up to confirm.');
        window.location.href = `https://app.wastedash.com/quote-redirect?quoteId=${ref.id}`;
      }).catch((error) => {
        this.loading = false;
        console.log(error);
        alert('Quote creation failed');
      });
    },
    async saveQuote() {
      this.buildBooking();
      let dataRef = collection(db, 'quotes');
      return addDoc(dataRef, this.booking).then((snapshot) => {
        return snapshot;
      });
    },
    buildBooking() {
      this.booking = {
        order: Number.parseInt(this.order + 1),
        orderNumber:{
          id: 1000, //starting the order id at 1000
          number: 1000
        },
        waste: {
          type: this.wasteType.key,
          name: this.wasteType.name
        },
        vehicle: {
          type: this.vehicle.type,
          name: this.vehicle.name
        },
        drivers: this.vehicle.drivers.map(d => d.id),
        driversTokens: this.vehicle.drivers.map(d => d.token ? d.token : ''),
        driverMobiles: this.vehicle.drivers.map(d => '+27' + d.mobile.substring(1,10)),
        customer:{
          mobile: this.mobile,
        },
        cost: {
          currency: 'USD',
          symbol: '$',
          value: this.vehicle.cost
        },
        capturedAddress: this.capturedAddress,
        postCode: this.location.postal_code ? this.location.postal_code : this.postCode,
        lat: this.location.latitude,
        long: this.location.longitude,
        status: {
          type: 'QUOTE',
          status: 'QUOTE'
        },
        timeStamp: this.timeStamp
      };
    }
  },
  computed:{
    order(){
      return this.$store.getters.getOrder;
    },
  },
  async mounted() {
    this.$store.dispatch('fetchOrder');
  }
}
</script>

<style scoped>

.min-width {
  width: 150px;
}

</style>
